<template>
    <AdaptersDialog
        :listener-id="listenerOpen"
        :header="$t('lang.wordstat.report.add_keys')"
        :loading="loading"
        :callback-on-hide="clearModel"
        :button-agree-label="$t('lang.main.btn.add')"
        :callback-agree="onImportFromFile"
        ref="popup"
    >
        <template #content>
            <div v-if="isDisabledSend" class="grid">
                <div  class="col-12">
                    <TemplatesDisabledParentProjectsMessage
                        :clusterUid="clusterUid"
                        :clusterName="clusterName"
                        :monitoringId="monitoringId"
                        :monitoringName="monitoringName"
                    />
                </div>
            </div>
            <div v-else class="grid">
                <div class="col-12">
                    <div class="field mb-0">
                        <label>{{ $t('lang.wordstat.report.label_parsing_types') }}</label>
                        <div class="formgroup-inline">
                            <div class="field-radiobutton">
                                <RadioButton v-model="model.parsingType" name="parsingType" :value="ProjectsConstants.PARSING_TYPE_PHRASES" input-id="label_wsw" />
                                <label for="label_wsw">{{ $t('lang.wordstat.report.label_wsw') }}</label>
                            </div>
                            <div class="field-radiobutton">
                                <RadioButton v-model="model.parsingType" name="parsingType" :value="ProjectsConstants.PARSING_TYPE_WS" input-id="label_ws" />
                                <label for="label_ws">{{ $t('lang.wordstat.report.label_ws') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="model.parsingType === ProjectsConstants.PARSING_TYPE_WS" class="col-12">
                    <div class="field mb-0">
                        <label class="required">{{ $t('lang.wordstat.update_project.label_frequency') }}</label>
                        <div class="formgroup-inline">
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WS]" binary inputId="frequency-ws" />
                                <label for="frequency-ws">{{ $t('lang.wordstat.update_project.frequency_ws') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_QWSK]" binary inputId="frequency-qwsk" />
                                <label for="frequency-qwsk">{{ $t('lang.wordstat.update_project.frequency_qwsk') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WSK]" binary inputId="frequency-wsk" />
                                <label for="frequency-wsk">{{ $t('lang.wordstat.update_project.frequency_wsk') }}</label>
                            </div>
                            <!-- 
                            TODO: временно закоментировано, расскоментировать переходе на получение частотки из бюджетов
                            <div v-if="source === ProjectsConstants.SOURCE_WS" class="field-checkbox">
                                <Checkbox
                                    v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_SWSK]"
                                    binary
                                    inputId="frequency-swsk"
                                />
                                <label for="frequency-swsk">{{ $t('lang.wordstat.update_project.frequency_swsk') }}</label>
                            </div>
                            <div v-else-if="source === ProjectsConstants.SOURCE_DIRECT" class="field-checkbox p-disabled">
                                <Checkbox binary inputId="frequency-swsk" :value="false" />
                                <label for="frequency-swsk">{{ $t('lang.wordstat.update_project.frequency_swsk') }}</label>
                            </div> -->
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_SWSK]" binary inputId="frequency-swsk" />
                                <label for="frequency-swsk">{{ $t('lang.wordstat.update_project.frequency_swsk') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox v-model="model.parse_budget_cpc" binary inputId="parse-budget-cpc" />
                                <label for="parse-budget-cpc">{{ $t('lang.wordstat.update_project.parse_budget_cpc') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="flex flex-column md:flex-row gap-3">
                        <div class="flex-order-2 md:flex-order-1">
                            <AdaptersFileUpload
                                mode="basic"
                                @select="selectFile"
                                :pt="{chooseButton: {class: 'p-button-sm p-button-secondary white-space-nowrap'}}"
                                :chooseLabel="$t('lang.wordstat.report.button_select_file')"
                                accept=".txt, .csv"
                            />
                        </div>
                        <div class="flex-order-1 md:flex-order-2">
                            <p class="p-0 m-0 text-xs text-gray-500" v-html="$t('lang.wordstat.sample_files')"></p>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="field">
                        <TemplatesLabelCounts
                            :text="$t('lang.wordstat.report.import_from_area_label')"
                            :count="getCountRows"
                            :limit="getLimit"
                        />
                        <Textarea v-model="model.list" :rows="6" />
                        <small>{{ $t('lang.wordstat.report.import_from_area_desc') }}</small>
                    </div>
                    <template v-if="isNotValid">
                        <AdaptersMessage :message="$t('lang.wordstat.report.import_from_area_not_valid_label')" />
                        <div class="field-checkbox">
                            <Checkbox v-model="isConfirmSkip" binary inputId="isConfirmSkip" />
                            <label for="isConfirmSkip">{{ $t('lang.wordstat.report.import_from_area_skip_label') }}</label>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template #footer v-if="model.parsingType === ProjectsConstants.PARSING_TYPE_WS">
            <div class="flex justify-content-between align-items-center w-full">
                <TemplatesLimits :limits="getCountLimits" />
                <div class="flex gap-2">
                    <Button :label="$t('lang.main.btn.add')" @click="onImportFromFile" :disabled="isDisableAdd" />
                    <Button :label="$t('lang.wordstat.report.import_from_area_close_label')" @click="onClose" class="p-button-text" />
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Textarea from "primevue/textarea";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import AdaptersDialog from "keysso/component/adapters/Dialog.vue";
import TemplatesLabelCounts from "keysso/templates/LabelCounts.vue";
import AdaptersFileUpload from "keysso/component/adapters/FileUpload.vue";
import {RowsHelper} from "keysso/helpers/RowsHelper";
import {Listeners} from "keysso/constants/listeners";
import WordstatApi from "keysso/api/WordstatApi";
import AdaptersMessage from "keysso/component/adapters/Message.vue";
import TariffAPI from "keysso/api/TariffAPI";
import Alerts from "keysso/mixins/Alerts";
import TemplatesDisabledParentProjectsMessage from "keysso/templates/DisabledParentProjectsMessage.vue";
import TemplatesLimits from "keysso/templates/Limits.vue";
import {ProjectsConstants} from "../constants/projectConstants";
import {DataTransformer} from "../DataTransformer";

export default {
    name: "WordstatImportFromArea",
    mixins: [Alerts],
    props: {
        id: {
            type: Number,
            required: true,
        },
        clusterUid: {
            type: String,
            required: false,
            default: null,
        },
        clusterName: {
            type: String,
            required: false,
            default: null,
        },
        monitoringId: {
            type: Number,
            required: false,
            default: null,
        },
        monitoringName: {
            type: String,
            required: false,
            default: null,
        },
        source: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            model: {
                list: null,
                parsingType: ProjectsConstants.PARSING_TYPE_PHRASES,
                frequency: {
                    [ProjectsConstants.FREQUENCY_TYPE_WS]: true,
                    [ProjectsConstants.FREQUENCY_TYPE_QWSK]: false,
                    [ProjectsConstants.FREQUENCY_TYPE_WSK]: false,
                    [ProjectsConstants.FREQUENCY_TYPE_SWSK]: false,
                },
                parse_budget_cpc: false,
            },
            listenerOpen: Listeners.WORDSTAT_POPUP_IMPORT_FROM_AREA,
            loading: false,
            limits: {
                wordstatPerMonth: {
                    limit: 0,
                    usedLimit: 0,
                },
                wordstatWordPerMonth: {
                    limit: 0,
                    usedLimit: 0,
                },
            },
            limitLoaded: false,
            isConfirmSkip: false,
        }
    },
    mounted() {
        if (!this.limitLoaded) {
            this.loading = true;
            TariffAPI
                .getLimits()
                .then(response => {
                    this.limits.wordstatPerMonth = response.wordstat.perMonth;
                    this.limits.wordstatWordPerMonth = response.wordstatWord.perMonth;
                    this.loadedLimit = true;
                })
                .finally(() => this.loading = false);
        }
    },
    computed: {
        isDisableAdd() {
            return (this.isNotValid && !this.isConfirmSkip) || this.isDisabledSend;
        },
        ProjectsConstants() {
            return ProjectsConstants
        },
        getCountRows() {
            return RowsHelper.getCountFromString(this.model.list);
        },
        getLimit() {
            return this.model.tabIndex === 0
                ? this.limits.wordstatWordPerMonth.limit - this.limits.wordstatWordPerMonth.usedLimit
                : this.limits.wordstatPerMonth.limit - this.limits.wordstatPerMonth.usedLimit;
        },
        isNotValid() {
            return !!RowsHelper
                .getArrayFromString(this.model.list)
                .some(item => item.length > 100 || item.trim().split(/\s+/).length > 13);
        },
        isDisabledSend() {
            return !!(this.clusterUid || this.monitoringId);
        },
        getCountLimits() {
            const countFrequency = (
                this.model.source === ProjectsConstants.SOURCE_WS
                    ? Object.keys(this.model.frequency).filter(key => this.model.frequency[key])
                    : Object
                        .keys(this.model.frequency)
                        .filter(key => this.model.frequency[key] && key !== ProjectsConstants.FREQUENCY_TYPE_SWSK)
            ).length;
            let countLimits = this.getCountRows * countFrequency;
            if (this.model.parse_budget_cpc) {
                countLimits += this.getCountRows;
            }

            return countLimits;
        },
    },
    methods: {
        onClose() {
            this.$refs.popup.onClose();
            this.clearModel();
        },
        onImportFromFile() {
            if (!this.getCountRows) {
                this.alertError(this.$t('lang.wordstat.report.error_empty_words'));
                return;
            }

            if (this.getCountRows > this.getLimit) {
                this.alertError(this.$t('lang.wordstat.report.error_limit'));
                return;
            }

            this.loading = true;
            const payload = DataTransformer.payloadUpdateWords({
                words: RowsHelper.getArrayFromString(this.model.list),
                parsingType: this.model.parsingType,
                frequency: this.model.frequency,
                parse_budget_cpc: this.model.parse_budget_cpc,
            });
            WordstatApi
                .updateWords(this.id, payload)
                .then(() => location.reload())
                .catch(error => this.alertError(error.message))
                .finally(() => this.loading = false);
        },
        clearModel() {
            this.model = {
                list: '',
                parsingType: ProjectsConstants.PARSING_TYPE_PHRASES,
                frequency: {
                    [ProjectsConstants.FREQUENCY_TYPE_WS]: true,
                    [ProjectsConstants.FREQUENCY_TYPE_QWSK]: false,
                    [ProjectsConstants.FREQUENCY_TYPE_WSK]: false,
                    [ProjectsConstants.FREQUENCY_TYPE_SWSK]: false,
                },
                parse_budget_cpc: false,
            };
        },
        selectFile(input) {
            const file = input.files.shift();
            const reader = new FileReader();
            const extension = file.name.split('.').pop().toLowerCase();

            reader.onload = event => {
                switch (extension) {
                    case 'txt':
                        this.model.list = event.target.result;
                        break;
                    case 'csv':
                        this.model.list = RowsHelper.getStringFromCsv(event.target.result);
                        break;
                }
            }
            reader.readAsText(file);
        },
    },
    components: {
        Button,
        TemplatesDisabledParentProjectsMessage,
        AdaptersMessage,
        AdaptersFileUpload,
        Textarea,
        TemplatesLabelCounts,
        AdaptersDialog,
        TabView,
        TabPanel,
        Checkbox,
        RadioButton,
        TemplatesLimits,
    }
}
</script>
